export const buttonOptions = {
    public: {
        first: { label: "Connexion", link: "/login" },
        second: { label: "Inscription", link: "/register" }
    },
    trader: {
        first: { label: "Profile", link: "/trader/profil" },
        second: { label: "Déconnexion", link: "/logout" }
    },
    client: {
        first: { label: "Profile", link: "/client/profil" },
        second: { label: "Déconnexion", link: "/logout" }
    },
    admin: {
        first: { label: "Profile", link: "/admin/profil" },
        second: { label: "Déconnexion", link: "/logout" }
    }
};
